export const getHeaderTextForInterview = (acceptedDate: number, typeName: string) => {
  return `${new Date(acceptedDate ?? '').toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  })} / Interview Center ${typeName}`
}
